import React, { Component } from 'react'

import { withRouter } from '@contexts/RouterProvider'
import { withSessionData } from '@contexts/SessionDataProvider'
import { withHttpService } from '@contexts/HttpServiceProvider'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from '@styles/indexPage'

export class Index extends Component {
  componentDidMount() {
    // Get field notebook URL from props (fetched by backend operation)
    const { model } = this.props

    // Redirect to field notebook URL (same behavior as if configuration was complete)
    if (model && model.url) {
      window.location.href = model.url
      return
    }

    // Fallback: if no field notebook URL is available, redirect to organization home
    console.error('No field notebook URL found for this organization')
    const pathMatch = window.location.pathname.match(/\/v4\/o\/(\d+)\//)
    if (pathMatch) {
      window.location.href = `/v4/o/${pathMatch[1]}/`
    }
  }

  render() {
    return null // Component redirects immediately, no UI needed
  }
}

export default withHttpService(withRouter(withSessionData(withStyles(styles)(Index))))
